/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { Spin } from 'antd'
import React, { HTMLAttributes, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTitle } from '@/hooks/useTitle'

export function BookDemo(props: React.PropsWithRef<HTMLAttributes<any>>) {
  const { t } = useTranslation()
  useTitle(t('Book a demo'))
  const [isLoading, setIsLoading] = useState(true)

  React.useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/embed/48104731.js'
    script.defer = true

    // 监听脚本加载完成
    script.onload = () => {
      // HubSpot 表单渲染需要一点时间
      setTimeout(() => setIsLoading(false), 1000)
    }

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <div className="demo-container" {...props}>
      <h1 className="center-center">{t('Get started with')}</h1>
      <p className="center-center" style={{ marginBottom: '24px' }}>
        Schedule a 30-minute product demo with expert Q&A
      </p>
      <div style={{ position: 'relative' }}>
        <Spin spinning={isLoading}>
          <div
            className="hs-form-frame"
            data-region="na1"
            data-form-id="77abfb77-19ae-47e5-bf11-821e41d9cdf0"
            data-portal-id="48104731"
            style={{
              minHeight: '800px',
            }}
          />
        </Spin>
      </div>
    </div>
  )
}
